import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "components/Button";
import Link from "next/link";
import dyanmicShortCodeText from "components/Contentful/utils";
import { kebabCase } from "lodash";

const OuterWrapper = styled.section`
  background-color: ${({ theme }) => theme.themeColors.orange1};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.5625rem;
  min-height: 24.25rem;
  ${({ theme }) => theme.mq.lg`
  padding: 4rem;
  `};
`;

const Header = styled.div`
  font-size: 2.375rem;
  font-weight: 600;
  color: ${({ theme }) => theme.themeColors.lightGreen3};
  line-height: 1.2;

  ${({ theme }) => theme.mq.lg`
    max-width: 45.9375rem;
    margin-bottom: 1rem;
    font-size: ${theme.fontSize(6)};
  `};
`;

const Subtitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize(2)};
  color: ${({ theme }) => theme.themeColors.lightGreen3};
  font-weight: 400;
  max-width: 32rem;
  margin: 1rem;
`;

const StyledButton = styled(Button)`
  max-width: 15.4375rem;
  margin: 1rem;
`;

const GenericCTABlock = ({ blockData, cityName, service }) => {
  const kebabCityName = kebabCase(cityName);

  const contentfulVarDict = {
    city: cityName,
    kebabCityName,
    serviceType: service,
  };

  const buttonText = dyanmicShortCodeText({
    textToSearch: blockData?.buttonText,
    replaceDictLookup: contentfulVarDict,
  });
  const subtitle = dyanmicShortCodeText({
    textToSearch: blockData?.subtitle,
    replaceDictLookup: contentfulVarDict,
  });
  const title = dyanmicShortCodeText({
    textToSearch: blockData?.title,
    replaceDictLookup: contentfulVarDict,
  });

  const link = dyanmicShortCodeText({
    textToSearch: blockData?.link,
    replaceDictLookup: contentfulVarDict,
  });

  return (
    <OuterWrapper>
      <Header> {title}</Header>
      <Subtitle>{subtitle}</Subtitle>
      {blockData?.link && (
        <Link href={link}>
          <StyledButton colorType="lightGreen3" textColor="primary">
            {buttonText}
          </StyledButton>
        </Link>
      )}
    </OuterWrapper>
  );
};

export default GenericCTABlock;

GenericCTABlock.propTypes = {
  blockData: PropTypes.shape({
    buttonText: PropTypes.string,
    link: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
  }),
  cityName: PropTypes.string,
  service: PropTypes.string,
};

GenericCTABlock.defaultProps = {
  blockData: undefined,
  cityName: "",
  service: "groomers",
};
